
import {forkJoin as observableForkJoin,  Observable } from 'rxjs';
import { UserResource } from './../../resources/user/user-resource';
import { Component, OnInit, ChangeDetectorRef, ApplicationRef } from '@angular/core';
import { NotificationsService } from "angular2-notifications";
import { NewsletterScheduleResource } from "app/models/NewsletterScheduleResource";
import { DatePickerOptions } from "app/calendar/ng2-datepicker.component";
import { Http, Response } from "@angular/http";
import { NewsletterSettingsService } from "app/newsletter/newsletter-settings/newsletter-settings.service";
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'vbn-newsletter-settings',
    providers: [NewsletterSettingsService],
    templateUrl: './newsletter-settings.component.html',
    styleUrls: ['./newsletter-settings.component.scss']
})
export class NewsletterSettingsComponent implements OnInit {

    month: boolean = true;
    daysArray: any = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21];
    dayNumber: number = 1;
    newsletterSchedule: NewsletterScheduleResource;
    errorMessage: any
    hours: number;
    minutes: number;
    date: any;
    moment: any;
    userEmail = localStorage.getItem("_user");


    constructor(private translate: TranslateService, private _notificationService: NotificationsService, private newsletterSettingsService: NewsletterSettingsService) {
        this.newsletterSchedule = new NewsletterScheduleResource();
        this.newsletterSchedule.active = false;
    }

    ngOnInit() {
        this.getNewsletterSchedule();
    }

    getNewsletterSchedule() {
        this.newsletterSettingsService.getNewsletterSchedule()
            .subscribe(
            response => {
                this.newsletterSchedule = response;
                this.moment = this.newsletterSchedule.startDate;
                console.log('success.GET newsletter schedule --->:', response);
                if (this.newsletterSchedule.interval == 30) {
                    this.month = true;
                } else {
                    this.month = false;
                    this.dayNumber = this.newsletterSchedule.interval;
                }
            },
            error => this.errorMessage = <any>error);
    }

   

    save = function () { 
        if (this.newsletterSchedule.active == true) {
            if(this.moment == undefined || this.moment == null){
                observableForkJoin(
                    this.translate.get('Invalid date'),
                    this.translate.get('You must select a date!')
                ).subscribe((res) => {
                    this._notificationService.create(res[0], res[1], 'error')
                })
                // this._notificationService.create("Invalid date", 'You must select a date!', 'error');
                return;
            }
            if (this.month == undefined) {
                observableForkJoin(
                    this.translate.get('Error Data'),
                    this.translate.get('No interval selected!')
                ).subscribe((res) => {
                    this._notificationService.create(res[0], res[1], 'error')
                })
                // this._notificationService.create("Error Data", 'No interval selected!', 'error');
            } else {
                if (this.month) {
                    this.newsletterSchedule.interval = 30;
                } else if (this.month == false) {
                    this.newsletterSchedule.interval = this.dayNumber;
                }
                this.newsletterSchedule.startDate = this.moment;
                this.newsletterSchedule.userEmail = this.userEmail;
                this.newsletterSettingsService.saveNewsletterSchedule(this.newsletterSchedule)
                    .subscribe(
                    response => {
                        console.log('succes.POST save  newsletter settings', response);
                        observableForkJoin(
                            this.translate.get('Success'),
                            this.translate.get('Newsletter settings have been successfully saved!')
                        ).subscribe((res) => {
                            this._notificationService.create(res[0], res[1], 'success')
                        })
                        
                        //this._notificationService.create("Success", 'Newsletter has been successfully added!', 'success')
                    },
                    error => {
                        this.errorMessage = <any>error
                        observableForkJoin(
                            this.translate.get('Error'),
                            this.translate.get('Newsletter settings could not be saved!')
                        ).subscribe((res) => {
                            this._notificationService.create(res[0], res[1], 'error')
                        })
                       
                        // this._notificationService.create("Error", 'Newsletter could not be added!', 'error')
                    });
            }
        } else {
            this.newsletterSchedule.userEmail = this.userEmail;
            this.newsletterSettingsService.saveNewsletterSchedule(this.newsletterSchedule)
                .subscribe(
                response => {
                    console.log('succes.POST save  newsletter settings', response);
                    observableForkJoin(
                        this.translate.get('Success'),
                        this.translate.get('Newsletter settings have been successfully saved!')
                    ).subscribe((res) => {
                        this._notificationService.create(res[0], res[1], 'success')
                    })
                   
                    //this._notificationService.create("Success", 'Settings have been successfully saved!', 'success')
                },
                error => {
                    this.errorMessage = <any>error
                    observableForkJoin(
                        this.translate.get('Error'),
                        this.translate.get('Newsletter settings could not be saved!')
                    ).subscribe((res) => {
                        this._notificationService.create(res[0], res[1], 'error')
                    })
                    //this._notificationService.create("Error", 'Settings could not be saved!', 'error')
                });
        }
    }
}







